import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import CitationsCitedRefsReorderCommand from "./citationscitedrefsreordercommand";

export default class CitationsCitedRefsReorderEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add(
      "citationscitedrefsreorder",
      new CitationsCitedRefsReorderCommand(editor)
    );
  }
}
